// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"de94a922","977":"9fb09758"}[chunkId] + ".chunk.js";
};